<template>
  <div>
    <div class="md-layout">
      <router-link to="/">Home </router-link>
      <label class="labelBar"> / </label>
      <router-link to="/limite"> Cadastro/Limites/Limite </router-link>
      <label class="labelBar"> / </label>
      <label> Editar</label>
    </div>
    <div class="md-layout">
      <div class="md-layout-item">
        <div class="md-layout">
          <div class="md-layout-item">
            <div class="md-layout">
              <md-field
                class="md-layout-item"
                :class="getValidationClass('perfilSelected')"
              >
                <label for="perfilSelected">Local</label>
                <md-select
                  v-model="perfilSelected"
                  name="perfilSelected"
                  id="perfilSelected"
                >
                  <md-option
                    v-for="item in perfis"
                    v-bind:key="item.id"
                    :value="item.id"
                    >{{ item.nome }}
                  </md-option>
                </md-select>

                <span class="md-error" v-if="!$v.perfilSelected.required"
                  >Perfil obrigatório</span
                >
              </md-field>
              <md-field
                class="md-layout-item"
                :class="getValidationClass('usuarioSelected')"
              >
                <label for="usuarioSelected">Local</label>
                <md-select
                  v-model="usuarioSelected"
                  name="usuarioSelected"
                  id="usuarioSelected"
                >
                  <md-option
                    v-for="item in usuarios"
                    v-bind:key="item.id"
                    :value="item.id"
                    >{{ item.nome }}
                  </md-option>
                </md-select>

                <span class="md-error" v-if="!$v.usuarioSelected.required"
                  >Usuário obrigatório</span
                >
              </md-field>
              <md-field
                class="md-layout-item"
                :class="getValidationClass('valorLimite')"
              >
                <label>Valor do Limite</label>
                <md-input 
                  v-model.lazy="valorLimite"
                  v-money="money"></md-input>
                <span class="md-error" v-if="!$v.valorLimite.required"
                  >Valor do limite obrigatório</span
                >
              </md-field>
            </div>
          </div>
        </div>
        <div class="md-layout-item">
          <div class="md-layout md-alignment-center-right">
            <md-button to="/limite" class="md-raised md-warning"
              >Voltar</md-button
            >
            <md-button @click="enviar" class="md-raised md-success"
              >Salvar</md-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import {
  editarLimiteAsync,
} from "../../../services/limiteService";
import { mapState } from "vuex";
import { VMoney } from "v-money";

export default {
  name: "editarLimite",
  data: () => ({
    valorLimite: null,
    perfilSelected: null,
    usuarioSelected: null,
    money: {
      decimal: ",",
      thousands: ".",
      prefix: "R$ ",
      //suffix: " #",
      precision: 2,
      masked: false,
    },
  }),
  directives: { money: VMoney },
  mixins: [validationMixin],
  validations: {
    valorLimite: { required },
    perfilSelected: { required },
    usuarioSelected: { required },
  },
  computed: {
    ...mapState("limite", ["limite"]),
    ...mapState("perfil", ["perfis"]),
    ...mapState("usuario", ["usuarios"]),
  },
  methods: {
    async enviar() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        const resposta = await editarLimiteAsync(
          this.perfilSelected,
          this.usuarioSelected,
          this.valorLimite.replace("R$ ", "")
        );
        if (resposta) {
          //this.mensagemErro = resposta;
          //this.mostartMensagemErro = true;
          this.$alert(resposta.message, "Descupe, falha na operação!", "error");
        } else {
          /*this.$fire({
            text: "Usuário editado com sucesso",
            type: "success",
            timer: 3000,
          });*/
          this.$router.push("/limite");
        }
      }
    },
    getValidationClass(fieldName) {
      const field = this.$v[fieldName];

      if (field) {
        return {
          "md-invalid": field.$invalid && field.$dirty,
        };
      }
    },
    findPerfil(perfilId) {
      return this.perfis.find((pf) => pf.id === perfilId);
    },
    findUsuario(usuarioId) {
      return this.usuarios.find((u) => u.id === usuarioId);
    },
  },
  created: function () {
    this.valorLimite = this.limite.valorLimite;
    this.perfilSelected = this.findPerfil(this.limite.idPerfil).id;
    this.usuarioSelected = this.findUsuario(this.limite.idUsuario).id;
  },
};
</script>

<style scoped>
.md-field {
  margin: 10px;
}

.vl {
  margin: 0px 50px;
  border-left: 2px dashed var(--md-theme-default-primary);
}

.icone-voltar {
  vertical-align: text-bottom;
}

.md-card {
  width: 140px;
  margin: 2px;
  display: inline-block;
  vertical-align: top;
}

.labelBar {
  margin-right: 10px;
  margin-left: 10px;
}
</style>